import { ContactDetailsContactInfoTab } from '@/views/contactsDetails/components/tabs/ContactDetailsContactInfoTab.comp.tsx';
import { ContactDetailsProcessesTab } from '@/views/contactsDetails/components/tabs/ContactDetailsProcessesTab.comp.tsx';
import { ContactDetailsTasksTab } from '@/views/contactsDetails/components/tabs/ContactDetailsTasksTab.comp.tsx';
import { ProcessDetailsFilesTab } from '@/views/processesDetails/components/tabs/ProcessDetailsFilesTab.comp.tsx';
import { ProcessDetailsMessagesRedirect } from '@/views/processesDetails/components/tabs/ProcessDetailsMessagesRedirect.comp.tsx';
import { ProcessDetailsMessagesTab } from '@/views/processesDetails/components/tabs/ProcessDetailsMessagesTab.comp.tsx';
import { ProcessDetailsMultiOffersTab } from '@/views/processesDetails/components/tabs/ProcessDetailsMultiOffersTab.comp.tsx';
import { ProcessDetailsTasksTab } from '@/views/processesDetails/components/tabs/ProcessDetailsTasksTab.comp.tsx';
import { ForbiddenView } from '@/views/util/forbidden/Forbidden.view.tsx';

import { RouteEnum, RouteModel } from './Route.model';

export const ROUTES: RouteModel[] = [
  {
    load: () => import('@/views/administration/Administration.view'),
    path: RouteEnum.ADMINISTRATION,
  },
  { load: () => import('@/views/settlements/Settlements.view'), path: RouteEnum.SETTLEMENTS },
  { load: () => import('@/views/hr/Hr.view'), path: RouteEnum.HR },
  { load: () => import('@/views/statistics/Statistics.view'), path: RouteEnum.STATISTICS },
  {
    load: () => import('@/views/dashboard/Dashboard.view'),
    path: RouteEnum.ROOT,
  },
  {
    load: () => import('@/views/dashboard/Dashboard.view'),
    path: RouteEnum.DASHBOARD,
  },
  {
    load: () => import('@/views/emails/Emails.view'),
    path: RouteEnum.EMAILS,
  },
  {
    load: () => import('@/views/chats/Chats.view.tsx'),
    path: RouteEnum.CHATS,
  },
  {
    load: () => import('@/views/calendar/Calendar.view'),
    path: RouteEnum.CALENDAR,
  },
  {
    load: () => import('@/views/contacts/Contacts.view'),
    path: RouteEnum.CONTACTS,
  },
  {
    load: () => import('@/views/contactsCreate/ContactsCreate.view'),
    path: RouteEnum.CONTACTS_CREATE,
  },
  {
    children: [
      { component: ContactDetailsContactInfoTab, index: true },
      { component: ContactDetailsTasksTab, path: 'tasks' },
      { component: ContactDetailsProcessesTab, path: 'processes' },
    ],
    load: () => import('@/views/contactsDetails/ContactDetails.view'),
    path: RouteEnum.CONTACTS_DETAILS,
  },
  {
    load: () => import('@/views/emergencyContacts/list/EmergencyContactsList.view'),
    path: RouteEnum.EMERGENCY_CONTACTS,
  },
  {
    load: () => import('@/views/emergencyContacts/details/EmergencyContactsDetails.view'),
    path: RouteEnum.EMERGENCY_CONTACTS_DETAILS,
  },
  {
    load: () => import('@/views/emergencyContacts/edit/EmergencyContactsEdit.view'),
    path: RouteEnum.EMERGENCY_CONTACTS_EDIT,
  },
  {
    load: () => import('@/views/contactsEdit/ContactsEdit.view'),
    path: RouteEnum.CONTACTS_EDIT,
  },
  {
    load: () => import('@/views/customers/list/Customers.view'),
    path: RouteEnum.CUSTOMERS,
  },
  {
    load: () => import('@/views/customers/createIndividual/CustomersCreateIndividual.view'),
    path: RouteEnum.CUSTOMERS_CREATE_INDIVIDUAL,
  },
  {
    load: () => import('@/views/cars/list/CarsList.view.tsx'),
    path: RouteEnum.CARS,
  },
  {
    load: () => import('@/views/cars/details/CarDetails.view.tsx'),
    path: RouteEnum.CARS_DETAILS,
  },
  {
    load: () => import('@/views/emergencyContacts/create/EmergencyContactsCreate.view'),
    path: RouteEnum.EMERGENCY_CONTACTS_CREATE,
  },
  {
    load: () => import('@/views/customers/createBusiness/CustomersCreateBusiness.view'),
    path: RouteEnum.CUSTOMERS_CREATE_BUSINESS,
  },
  {
    load: () => import('@/views/customers/createForeign/CustomersCreateForeign.view'),
    path: RouteEnum.CUSTOMERS_CREATE_FOREIGN,
  },
  {
    load: () => import('@/views/customerDetails/CustomerDetails.view'),
    path: RouteEnum.CUSTOMERS_DETAILS,
  },
  {
    load: () => import('@/views/customerEdit/CustomerEdit.view'),
    path: RouteEnum.CUSTOMERS_EDIT,
  },
  {
    load: () => import('@/views/processes/list/ProcessesList.view.tsx'),
    path: RouteEnum.PROCESSES,
  },
  {
    load: () => import('@/views/processesCreate/ProcessesCreate.view'),
    path: RouteEnum.PROCESSES_CREATE,
  },
  {
    children: [
      { component: ProcessDetailsMessagesTab, index: true },
      { component: ProcessDetailsTasksTab, path: 'tasks' },
      { component: ProcessDetailsMultiOffersTab, path: 'offers' },
      { component: ProcessDetailsMessagesRedirect, path: 'messages' },
      { component: ProcessDetailsFilesTab, path: 'files' },
    ],
    load: () => import('@/views/processesDetails/ProcessDetails.view'),
    path: RouteEnum.PROCESSES_DETAILS,
  },
  {
    load: () => import('@/views/tasks/list/TasksList.view'),
    path: RouteEnum.TASKS,
  },
  {
    load: () => import('@/views/tasks/details/TaskDetails.view'),
    path: RouteEnum.TASK_DETAILS,
  },
  {
    load: () => import('@/views/catalog/Catalog.view'),
    path: RouteEnum.CATALOG,
  },
  {
    load: () => import('@/views/dishes/list/DishesList.view'),
    path: RouteEnum.DISHES,
  },
  {
    load: () => import('@/views/dishesImport/DishesImport.view'),
    path: RouteEnum.DISHES_IMPORT,
  },
  {
    load: () => import('@/views/pptxImport/PptxImports.view'),
    path: RouteEnum.PPTX_IMPORTS,
  },
  {
    load: () => import('@/views/pptxImport/PptxImportDraft.view'),
    path: RouteEnum.PPTX_IMPORT_DETAILS,
  },
  {
    load: () => import('@/views/dishes/details/DishDetails.view'),
    path: RouteEnum.DISHES_DETAILS,
  },
  {
    load: () => import('@/views/dictionaries/list/DictionariesList.view'),
    path: RouteEnum.DICTIONARIES,
  },
  {
    load: () => import('@/views/reports/Reports.view'),
    path: RouteEnum.REPORTS,
  },
  {
    load: () => import('@/views/users/list/UsersList.view'),
    path: RouteEnum.USERS,
  },
  {
    component: ForbiddenView,
    path: RouteEnum.FORBIDDEN,
  },
  {
    load: () => import('@/views/processes/offer/ProcessOffer.view'),
    path: RouteEnum.PROCESSES_DETAILS_OFFER_CREATE,
  },
  {
    load: () => import('@/views/processes/offer/ProcessOffer.view'),
    path: RouteEnum.PROCESSES_DETAILS_OFFER,
  },
  {
    load: () => import('@/views/processes/multiOffer/ProcessMultiOffer.view'),
    path: RouteEnum.PROCESSES_DETAILS_MULTI_OFFER_CREATE,
  },
  {
    load: () => import('@/views/processes/multiOffer/ProcessMultiOffer.view'),
    path: RouteEnum.PROCESSES_DETAILS_MULTI_OFFER,
  },
  {
    load: () => import('@/views/offerElements/list/OfferElementsList.view'),
    path: RouteEnum.OFFER_ELEMENTS,
  },
  {
    load: () => import('@/views/offerGroupDefinitions/details/OfferGroupDefinitionDetails.view'),
    path: RouteEnum.OFFER_GROUP_DEFINITION_DETAILS,
  },
  {
    load: () => import('@/views/offerGroupDefinitions/list/OfferGroupDefinitionsList.view'),
    path: RouteEnum.OFFER_GROUP_DEFINITIONS,
  },
  {
    load: () => import('@/views/offers/createPredefined/OffersCreatePredefined.view'),
    path: RouteEnum.OFFERS_CREATE_PREDEFINED,
  },
  {
    load: () => import('@/views/offers/list/OffersList.view'),
    path: RouteEnum.OFFERS,
  },
  {
    load: () => import('@/views/offerElements/list/OfferElementsList.view'),
    path: RouteEnum.OFFER_ELEMENT_DETAILS,
  },
  {
    load: () => import('@/views/suppliers/list/SuppliersList.view'),
    path: RouteEnum.SUPPLIERS,
  },
  {
    load: () => import('@/views/suppliers/details/SupplierDetails.view'),
    path: RouteEnum.SUPPLIERS_DETAILS,
  },
];
